import { create } from 'zustand';

const useTaxStore = create((set) => ({
  groupedTaxes: {}, // o estado principal

  setGroupedTaxes: (taxes: any) => set({ groupedTaxes: taxes }),

  clearGroupedTaxes: () => set({ groupedTaxes: {} }),
}));

export default useTaxStore;